import { ActionTree } from 'vuex';
import axios from 'axios';
import { ProfessionalState, Professional, RootState } from './professional-types';

export const actions: ActionTree<ProfessionalState, RootState> = {
  async getProfessional({ commit }): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-professional' }).then(
      (response) => {
        const payload: Professional = response && response.data;
        commit('setProfessionalInState', payload);
      },
      (error) => {
        console.log(error);
        commit('profileError');
      },
    );
  },
};
